import { Bar, BarChart, Cell } from 'recharts'

export const Trendline = ({ data }) => {
  return (
    <div style={{ padding: '1px 0' }}>
      <BarChart
        width={22}
        height={14}
        data={data}
        margin={{ top: 0, left: 0, bottom: 0, right: 0 }}
        style={{ margin: 'auto' }}
      >
        <Bar dataKey="value" radius={1} maxBarSize={4}>
          {data.map((_, index) => (
            <Cell
              key={`cell-${index}`}
              fill={index === data.length - 1 ? '#0553A5' : '#006AA6'}
            />
          ))}
        </Bar>
      </BarChart>
    </div>
  )
}
